import React from 'react'
import DepartmentCard from '../../Components/Department/DepartmentCard'
import { SearchAndAddBtn } from '../../Components'

export const Department = () => {
    return (
        <>
            <div className='mb-0'>
                <SearchAndAddBtn title={`Department`} />
            </div>
            <div className="grid grid-cols-4 gap-4">
                <DepartmentCard />
                <DepartmentCard />
                <DepartmentCard />
                <DepartmentCard />
            </div>
        </>
    )
}

export default Department
